import { useCallback } from "react";
import {
  useDisableProduct,
  useEnableProduct,
} from "../mutations/useStatusProductToggle.mutation";

export const useProductStatusToggle = () => {
  const disableMutation = useDisableProduct();
  const enableMutation = useEnableProduct();

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleDisable,
    isDisabling: disableMutation.isPending,
    handleEnable,
    isEnabling: enableMutation.isPending,
  };
};
